export const healthInsurance = [
  {
    path: '/convenio',
    name: 'insurance-card',
    component: () => import('@/views/payment/healthInsurance/InsuranceCard.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Convênio',
        routeName: 'questions',
      },
    },
  },
  {
    path: '/cadastro-convenio/:path',
    name: 'change-insurance',
    component: () => import('@/views/payment/healthInsurance/InsuranceOptions.view.vue'),
    meta: {
      header: {
        routeName: 'insurance-card',
      },
    },
  },

  // Health Insurance Authorizer
  {
    path: '/autorizacao-amil',
    name: 'validation-token-amil',
    component: () => import('@/views/payment/healthInsurance/authorizer/TokenAmil.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Token Amil',
        fixed: true,
      },
    },
  },
  {
    path: '/token-amil-carregando',
    name: 'validation-loading',
    component: () =>
      import('@/views/payment/healthInsurance/authorizer/responses/ValidationLoading.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
      },
    },
  },
  {
    path: '/token-amil-resposta',
    name: 'validation-response',
    component: () =>
      import('@/views/payment/healthInsurance/authorizer/responses/ValidationResponse.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
      },
    },
  },
  {
    path: '/token-amil/guiche',
    name: 'validation-service-desk',
    component: () =>
      import('@/views/payment/healthInsurance/authorizer/responses/ValidationDenied.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Atendimento no guichê',
      },
    },
  },
];

export const healthInsuranceNoHeader = [
  // no header
  {
    path: '/convenio-autorizado',
    name: 'insurance-authorized',
    component: () => import('@/views/payment/healthInsurance/authorizer/AuthSuccess.vue'),
  },
];
